import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Home from './home.jsx';
import Discovery from './discovery.jsx';
import FAQ from './faq.jsx'; 
import LandingPage from './landingpage.jsx';// Import your FAQ component

function App() {
  return (
    <Router>
      <div className="App">
        <header className="App-header">
          {/* Common header content */}
        </header>
        <main>
          <Switch>
            <Route path="/" exact component={LandingPage}/>
            <Route path="/classic" component={Home} />
            <Route path="/discovery" component={Discovery} />
            <Route path="/faq" component={FAQ} />
          </Switch>
        </main>
      </div>
    </Router>
  );
}

export default App;
